<!--
 * @Description:
 * @Author: xiaoyao
 * @since: 2020-06-16 15:08:38
 * @LastAuthor: @yangwenshan
 * @lastTime: 2021-10-14 17:13:52
-->
<template>
  <div class="logo">
    <router-link :to="{name:'Workplace'}">
      <img :src="curOrgSetting.menu_logo_url" class="cutom" alt="logo">
      <h1 v-if="showTitle">{{ title }}</h1>
    </router-link>
  </div>
</template>

<script>
    import { mapGetters } from "vuex";
  export default {
    name: 'Logo',
      computed: {

          ...mapGetters({
              curOrgSetting: "orgSetting/curOrgSetting",
          }),
      },
    props: {
      title: {
        type: String,
        default: '启点车险',
        required: false
      },
      showTitle: {
        type: Boolean,
        default: true,
        required: false
      }
    }
  }
</script>

<style lang="less" scoped>
.logo {
    display: flex;
    /*justify-content: center;*/
    align-items: center;

  .cutom{
    height: 44px;
    width: auto;
    border-style: none;
      margin: 0 auto;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Tools/Logo.vue